// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__koo0J","field":"styles_field__10u6R","fieldCol":"styles_fieldCol__1Hqo0","diffCol":"styles_diffCol__2z4JY","diff":"styles_diff__2ZV0O"};